// extracted by mini-css-extract-plugin
export default {"adminLayout":"AdminLayout_adminLayout__vvMim","adminOutlet":"AdminLayout_adminOutlet__ChfqJ"};